import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { stringify } from 'query-string';
import { Link } from 'react-router-dom';
import { propArrayShape, propStr, } from '../../../../../../../../../helpers/custom-prop-types';
import TagIcon from '../../../../../../../../Icon/Svg/TagIcon';
import Hover from '../../../../../../../../Ui/System/Hover';
/**
 * Prpffit Searchの人気タグ一覧を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchSlideTagsContentList = (props) => {
    const { className, tags } = props;
    return (_jsx("ul", Object.assign({ className: clsx('professional_mypage_top_proffit_search_slide_tags_list', className) }, { children: tags.map((v) => (_jsx(Hover, { children: _jsx("li", Object.assign({ className: 'tag_item' }, { children: _jsxs(Link, Object.assign({ className: 'item_inner', to: `/proffit_search/search?${stringify({ slideTypes: v.id })}` }, { children: [_jsx(TagIcon, { className: 'item_icon gray' }), _jsx("span", Object.assign({ className: 'item_text' }, { children: v.name }))] })) })) }, v.id))) })));
};
ProfessionalMyPageTopProffitSearchSlideTagsContentList.propTypes = {
    className: propStr(),
    tags: propArrayShape().isRequired,
};
ProfessionalMyPageTopProffitSearchSlideTagsContentList.defaultProps = {
    className: '',
};
export default ProfessionalMyPageTopProffitSearchSlideTagsContentList;
